<template>
  <div class="admin" v-if="label">
    <!-- Mobile, tablet -->
    <div class="menu-mobile" v-if="windowWidth <= 1080">
      <label class="label">{{label.buttons.navigation}}</label>
      <div class="control">
        <div class="dropdown" :class="{'is-active': adminDropActive}">
          <div class="dropdown-trigger">
            <button
              class="button"
              type="button"
              @click="adminDropActive = !adminDropActive"
              @blur="adminDropActive = false">
              <span>{{adminText}}</span>
              <span class="icon is-small"><awesome-icon icon="angle-down" aria-hidden="true"/></span>
            </button>
          </div>
          <div class="dropdown-menu " role="menu">
            <div class="dropdown-content">
              <a class="dropdown-item" @mousedown="$router.push('/admin/users', () => {})">{{label.buttons.users}}</a>
              <a class="dropdown-item" @mousedown="$router.push('/admin/hpRequests', () => {})">Demandes d'accès</a>
              <a v-if="userIsAdmin" class="dropdown-item" @mousedown="openAdminManual">
                Manuel admin
                <span class="icon is-small"><awesome-icon icon="external-link-alt" aria-hidden="true"/></span>
              </a>
              <!-- <a class="dropdown-item" @mousedown="$router.push('/admin/notifications', () => {})">{{label.buttons.announcement}}</a> -->
              <!-- <a class="dropdown-item" @mousedown="$router.push('/admin/alertLogs', () => {})">{{label.buttons.alertLogs}}</a> -->
              <!-- <a class="dropdown-item" @mousedown="$router.push('/admin/optInLogs', () => {})">{{label.buttons.optInLogs}}</a> -->
              <!-- <a class="dropdown-item" @mousedown="$router.push('/admin/labels', () => {})">{{label.buttons.labels}}</a> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Desktop -->
    <aside class="menu" v-else>
      <p class="menu-label">
        {{label.titles.manageUsers}}
      </p>
      <ul class="menu-list">
        <li><router-link :class="{ 'is-active': this.$route.path == '/admin/users'}" to="/admin/users">{{label.buttons.users}}</router-link></li>
        <!-- <li><router-link :class="{ 'is-active': this.$route.path == '/admin/notifications'}" to="/admin/notifications">{{label.buttons.announcement}}</router-link></li> -->
      </ul>

      <p class="menu-label">
        Gestion des accès
      </p>
      <ul class="menu-list">
        <li><router-link :class="{ 'is-active': this.$route.path == '/admin/hpRequests'}" to="/admin/hpRequests">Demandes d'accès</router-link></li>
        <li><router-link :class="{ 'is-active': this.$route.path == '/admin/eoc'}" to="/admin/eoc">Fins de contrat</router-link></li>
        <!-- <li><router-link :class="{ 'is-active': this.$route.path == '/admin/notifications'}" to="/admin/notifications">{{label.buttons.announcement}}</router-link></li> -->
      </ul>

      <!-- admin manual -->
      <p v-if="userIsAdmin" class="menu-label">
        Aide
        <ul class="menu-list">
          <li><a href="#" @click.prevent="openAdminManual">Manuel admin<span class="icon is-small"><awesome-icon icon="external-link-alt" aria-hidden="true"/></span></a></li>
        </ul>
      </p>

      <!-- <p class="menu-label">
        {{label.titles.history}}
      </p>
      <ul class="menu-list">
        <li><router-link :class="{ 'is-active': this.$route.path == '/admin/alertLogs'}" to="/admin/alertLogs">{{label.buttons.alertLogs}}</router-link></li>
        <li><router-link :class="{ 'is-active': this.$route.path == '/admin/optInLogs'}" to="/admin/optInLogs">{{label.buttons.optInLogs}}</router-link></li>
      </ul> -->

      <!-- <p class="menu-label">
        {{label.titles.stats}}
      </p>
      <ul class="menu-list">
        <li><a href="https://analytics.google.com/analytics/web/" target="_blank">Google analytics <span class="icon is-small"><awesome-icon icon="external-link-alt" aria-hidden="true"/></span></a></li>
        <li><a href="https://www.hotjar.com/" target="_blank">Hotjar <span class="icon is-small"><awesome-icon icon="external-link-alt" aria-hidden="true"/></span></a></li>
      </ul> -->

      <!-- <p class="menu-label">
        {{label.titles.pages}}
      </p>
      <ul class="menu-list">
        <li><router-link :class="{ 'is-active': this.$route.path == '/admin/labels'}" to="/admin/labels">{{label.buttons.labels}}</router-link></li>
      </ul> -->
    </aside>

    <div class="admin-content box">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { getInstance } from "../../auth";
import { config } from "../../helpers";

export default {
  data() {
    return {
      windowWidth: window.innerWidth,
      adminDropActive: false
    }
  },
  computed: {
    ...mapState({ label: state => state.labels.admin }),
    ...mapGetters("account", ["userIsAdmin"]),
    adminText() {
      let routeName = this.$route.path.replace("/admin/", "")
      return this.label.buttons[routeName]
    }
  },
  methods: {
    ...mapActions("labels", ["getLabel"]),
    async openAdminManual() {
      if (!this.userIsAdmin) {
        const auth = getInstance()

        if (auth && typeof auth.loginWithRedirect === 'function') {
          await auth.loginWithRedirect({ appState: { targetUrl: '/admin' } })
          return
        }

        this.$router.push({ path: '/', query: { redirectError: true, source: '/admin' } })
        return
      }

      const token = localStorage.getItem("auth_token")
      const adminManualUrl = process.env.VUE_APP_ENV === 'prod'
        ? '/api/admin-docs/index.html'
        : `${config.apiUrl}/api/admin-docs/index.html`
      const response = await fetch(adminManualUrl, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        credentials: 'include'
      })

      if (response.status === 401 || response.status === 403) {
        this.$router.push({ path: '/', query: { redirectError: true, source: '/admin' } })
        return
      }

      if (!response.ok) {
        throw new Error("Unauthorized access to admin manual")
      }

      window.open(adminManualUrl, '_blank')
    }
  },
  created() {
    this.windowWidth = window.innerWidth
    if (this.$route.path === '/admin') this.$router.push("/admin/users", () => {});
    this.getLabel({ view: 'admin' })
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  }
}
</script>

<style lang="scss" scoped>
.admin {
  display: grid;
  grid-template-columns: 230px minmax(0, 1fr);
  grid-template-rows: minmax(calc(100vh - 71.99px), min-content);

  &-content {
    margin: 40px auto auto 40px;
    padding: 40px;
  }
}

@media screen and (max-width: 1080px) {
  .admin {
    display: flex;
    flex-direction: column;

    &-content {
      margin: 0;
    }
  }
}

.is-active {
  border-radius: 4px;
  background-color: #8796c9 !important;
}

.menu {
  background-color: white;
  padding: 20px;

  &-mobile {
    margin: 1rem auto;
  }
}
</style>